import styled from "@emotion/styled";

export const StyledItemRow = styled("tr")`
  height: 60px;
`;
